<template>
  <Block class="activity-time" title="获奖作品">
    <div class="wrapper">
      <div class="header">
        <span>专家评审奖</span>
      </div>
      <!-- 一等奖 -->
      <VueLazyImg classStyle="title" :src="isMobile
        ? 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/435cdd04-1fd2-40e8-8c4e-0a1cc574ca45.png'
        : 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/f54f28f1-d8b1-4524-bd47-d4a3aef3b29f.png'" />
      <div class="work-wrapper first">
        <div class="work-box" v-for="(it, i) in dataSource.expertReview.first">
          <div>
            <Photo class="photo" :item="it" @onPlay="handlePlay(dataSource.expertReview.first, i)">
              <template #header>
                <img class="left-top-img" :src="getLeftTopImg(it)" />
              </template>
            </Photo>
            <div class="intro-text">
              <img style="width: 100%;" :src="getLeftBottomImg(it)" />
            </div>
          </div>
        </div>
      </div>
      <!-- 二等奖 -->
      <VueLazyImg classStyle="title second" :src="isMobile
        ? 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/b2e9a276-a680-465b-b54d-a2a98cd44a80.png'
        : 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/45dd772f-e88c-4479-b1c1-b5ea7a9932c5.png'" />
      <div class="work-wrapper two secondChannel">
        <!-- 烟火人间 -->
        <div class="work-item">
          <div class="subTitle">
            <img :src="isMobile
              ? 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/5fc704ce-dbd9-40b5-8ba7-4204c8a3b4bc.png'
              : 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/befa4f3a-0bc4-46a4-96d4-710055f9d96d.png'
              " />
          </div>
          <div class="work-box">
            <Photo class="photo" v-for="(it, i) in dataSource.expertReview.secondChannel1" :item="it"
              @onPlay="handlePlay(dataSource.expertReview.secondChannel1, i)" />
          </div>
        </div>
        <!-- 广告天才 -->
        <div class="work-item">
          <div class="subTitle">
            <img
              :src="isMobile
                ? 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/a6d253a9-9a5b-4c36-a497-80a509aabbab.png'
                : 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/692615fb-27dd-4b52-8448-e9c15d4b8e1e.png'" />
          </div>
          <div class="work-box">
            <Photo class="photo" v-for="(it, i) in dataSource.expertReview.secondChannel2" :item="it"
              @onPlay="handlePlay(dataSource.expertReview.secondChannel2, i)" />
          </div>
        </div>
        <!-- 灵感无限 -->
        <div class="work-item">
          <div class="subTitle">
            <img
              :src="isMobile
                ? 'https://p4-ky.wsukwai.com/kos/nlav12119/MKqTffXW_2024-08-14-21-04-14.png'
                : 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/6b22d098-d0d7-4f07-b0df-07b157ef4413.png'" />
          </div>
          <div class="work-box">
            <Photo class="photo" v-for="(it, i) in dataSource.expertReview.secondChannel3" :item="it"
              @onPlay="handlePlay(dataSource.expertReview.secondChannel3, i)" />
          </div>
        </div>
      </div>
    </div>
    <div class="wrapper kuaishouPopularity">
      <div class="header">
        <span>快手人气奖</span>
      </div>
      <!-- 一等奖 -->
      <VueLazyImg classStyle="title" :src="isMobile
        ? 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/d98c9cbf-432c-43b4-bdfb-5d3e0042f17c.png'
        : 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/dc42a709-5020-4bc5-b90b-316b159cd556.png'" />
      <div class="work-wrapper first">
        <div class="work-box" v-for="(it, i) in dataSource.kuaishouPopularity.first">
          <div
            style="display: flex;flex-direction: column;max-width: 9rem; justify-content: center;align-items: center;">
            <Photo class="photo" :item="it" @onPlay="handlePlay(dataSource.kuaishouPopularity.first, i)" />
            <div class="intro-text">
              <img style="width: 100%;"
                :src="isMobile ?
                  'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/d8699254-882c-48e6-95a7-1c45c30a3b79.png'
                  : 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/def1a261-9c6b-4e78-9326-edabb1a0330c.png'" />
            </div>
          </div>
        </div>
      </div>
      <!-- 二等奖 -->
      <VueLazyImg classStyle="title second popular" :src="isMobile
        ? 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/b0ef3bcd-ee1e-4d5b-b066-6ea07ad73ec6.png'
        : 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/60ae763e-f225-4538-a441-2b879e05b3ba.png'" />
      <div class="work-wrapper secondChannel">
        <div class="work-box">
          <Photo class="photo" v-for="(it, i) in dataSource.kuaishouPopularity.second" :item="it"
            @onPlay="handlePlay(dataSource.kuaishouPopularity.second, i)" />
        </div>
      </div>
    </div>
    <div style="cursor: pointer;" @click="handleClick" class="bottom-btn">
      <img
        :src="isMobile
          ? 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/eeb829b7-d83b-4535-b056-5b04e8b5c474.png'
          : 'https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/6c70a5db-5847-41e1-be1b-d14ea08a6433.png'" />
    </div>
  </Block>
</template>
<script setup lang="ts">
import { ApiModal } from '#imports';
import VueLazyImg from '../VueLazyImg.vue';
import { getRewardList, PublishListItemWithChannel, RewardLevel } from './common/api/request';
import Block from './common/block.vue';
import Photo from './common/Photo.vue';
import useDevice from './common/useDevice';
import VideoPlayModal from './modal/videoPlayModal.vue';
import isInKwaiying from "@ky/sdk/dist/isInKwaiying";
import open from "@ky/sdk/dist/open";

const dataSource = ref<{
  expertReview: {
    first: PublishListItemWithChannel[];
    secondChannel1: PublishListItemWithChannel[];
    secondChannel2: PublishListItemWithChannel[];
    secondChannel3: PublishListItemWithChannel[];
  },
  kuaishouPopularity: {
    first: PublishListItemWithChannel[];
    second: PublishListItemWithChannel[];
  },
}>(
  {
    expertReview: {
      first: [],
      secondChannel1: [],
      secondChannel2: [],
      secondChannel3: [],
    },
    kuaishouPopularity: {
      first: [],
      second: [],
    },
  }
)

const loading = ref(false);
const { isMobile, isKs } = useDevice();
const playModal = ref<ApiModal<typeof VideoPlayModal>>();

const getLeftTopImg = (it: PublishListItemWithChannel) => {
  const map: Record<number, string> = {
    /** 烟火人间 */
    1: `https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/df679b88-93ba-40d1-a6b6-52ec717c6087.png`,
    /** 广告天才 */
    2: `https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/cc8015f8-a0f4-40eb-8a63-95549129b118.png`,
    /** 灵感无限 */
    3: `https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/10d0b090-de0d-44f1-b36a-6d171a830890.png`
  };
  return map[it?.channel];
}

const getLeftBottomImg = (it: PublishListItemWithChannel) => {
  const mobileMap: Record<number, string> = {
    /** 烟火人间 */
    1: `https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/4511f43a-1513-427a-8d90-28a54b1f61d7.png`,
    /** 广告天才 */
    2: `https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/8c591a8e-12b0-4a4c-b462-03ab8a168844.png`,
    3: `https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/3e8f205b-3c3c-4ba8-b5a8-50f1a6d08807.png`
  };
  if (isMobile.value) return mobileMap[it?.channel];
  const map: Record<number, string> = {
    /** 烟火人间 */
    1: `https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/e65769cc-ef94-47f2-80b4-b76696e5704b.png`,
    /** 广告天才 */
    2: `https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/80d6eb80-9593-447e-8c0b-0bc77de00d41.png`,
    /** 灵感无限 */
    3: `https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/644b4e94-0fa6-462d-9ad3-5645b5cbc0c0.png`
  };
  return map[it?.channel];
}

const getData = () => {

  loading.value = true;
  return getRewardList()
    .then((res) => {
      const { data } = res;
      const transfer = (record: RewardLevel['expertReview'] | RewardLevel['kuaishouPopularity']): PublishListItemWithChannel[] => {
        return Object.entries(record).reduce((arr, [key, values]) =>
          [...arr, ...values.map((it) => ({
            ...it,
            channel: Number(key),
          } as PublishListItemWithChannel))
          ], [] as PublishListItemWithChannel[])
      };
      dataSource.value.expertReview.first = transfer(data?.firstLevel?.expertReview);
      const secondExpertRiewLevel = transfer(data?.secondLevel?.expertReview);
      dataSource.value.expertReview.secondChannel1 = secondExpertRiewLevel?.filter(it => it.channel === 1);
      dataSource.value.expertReview.secondChannel2 = secondExpertRiewLevel?.filter(it => it.channel === 2);
      dataSource.value.expertReview.secondChannel3 = secondExpertRiewLevel?.filter(it => it.channel === 3);
      dataSource.value.kuaishouPopularity.first = transfer(data?.firstLevel?.kuaishouPopularity);
      dataSource.value.kuaishouPopularity.second = transfer(data?.secondLevel?.kuaishouPopularity);
    })
    .finally(() => (loading.value = false));
};

const handlePlay = (items: PublishListItemWithChannel[], index: number) => {
  if (!playModal.value) {
    playModal.value = new ApiModal(VideoPlayModal);
  }
  playModal.value.show({
    // @ts-ignore
    closeOnClickOverlay: isMobile.value,
    items: items,
    index,
    allowPCFullScreen: true,
    // @ts-ignore
    onNext: async () => {
      await getData();
      playModal.value?.show({ items: items, index, allowPCFullScreen: true });
      playModal.value?.instance?.$forceUpdate(); // 触发强制更新
    },
    onClose() {
      playModal.value?.destroy();
    }
  });
};

const handleClick = () => {
  const url = `https://docs.qingque.cn/d/home/eZQDExfLm2OdwsrSQ-nlqbIuI?identityId=1rm7UUTeCNX`;
  if (isInKwaiying() || isKs.value) {
    open(`kwaiying://web?url=${encodeURIComponent(url)}&showTopBar=true`);
  } else {
    window.open(url, "_blank");
  }
};

onMounted(() => {
  getData();
});

</script>
<style scoped lang="less">
.activity-time {

  margin-bottom: 1.4rem;

  @media screen and (max-width:1360px) {
    padding-top: 0;
    margin-bottom: .8rem;
  }

  :deep(.wrapper.card) {
    padding-top: 0;

    @media screen and (max-width:1360px) {
      padding-top: .4rem;
    }
  }

  .wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    color: #fff;

    @media screen and (max-width:1360px) {
      margin-bottom: .32rem;
    }

    .header {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: .8rem 0 .6rem;

      @media screen and (max-width:1360px) {
        margin: .32rem 0 .2rem;
      }

      span {
        font-size: .6rem;
        font-weight: 500;
        line-height: .8rem;
        color: #fff; // 设置文本颜色为白色，但会被下面的渐变色覆盖
        mix-blend-mode: screen; // 使用screen混合模式使渐变色在黑色背景上可见
        -webkit-text-fill-color: transparent;
        background: linear-gradient(97.03deg, #FFFFFF 20.89%, #B5FFDF 62.65%, #9CEDFF 83.53%);
        background-clip: text;

        @media screen and (max-width:1360px) {
          font-size: .32rem;
          line-height: .4rem;
          font-weight: 600;
        }
      }

    }

    .work-wrapper {
      display: flex;
      align-items: center;

      &.first {
        display: grid;
        justify-content: center;
        grid-template-columns: repeat(3, 1fr);
        column-gap: .1rem;
        row-gap: .1rem;

        @media screen and (max-width:1360px) {
          grid-template-columns: repeat(1, 1fr);
          column-gap: 0;
          row-gap: .08rem;
        }
      }

      @media screen and (max-width:1360px) {
        flex-direction: column;
      }

      &.two {
        flex-direction: column;
      }

      .work-item {
        width: 100%;
        display: flex;
        flex-direction: column;

        .subTitle {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: .52rem 0;

          @media screen and (max-width:1360px) {
            padding: .4rem 0 .32rem 0;
            justify-content: flex-start;
          }

          img {
            display: inline-block;
            width: auto;
            height: .56rem;

            @media screen and (max-width:1360px) {
              height: .32rem;
            }
          }
        }
      }

      .work-box {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        overflow: hidden;
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: .1rem;


        @media screen and (max-width:1360px) {
          // flex-direction: column;
          // justify-content: center;
          // align-items: flex-start;
          // margin-bottom: .08rem;
          grid-template-columns: repeat(1, 1fr);
          gap: .08rem;
        }

        .photo {
          max-width: 9rem;
          width: 100%;
          height: 5.04rem;
          cursor: pointer;
          margin-bottom: 0;

          :deep(.play) {
            width: .88rem;
            height: .88rem;
          }

          @media screen and (max-width:1360px) {
            width: 100%;
            height: 3.76rem;
            border: .08rem;
          }

          :deep(.left-top-img) {
            // width: 1.92rem;
            height: .72rem;
            margin: .24rem 0 0 .24rem;

            @media screen and (max-width:1360px) {
              margin: .16rem 0 0 .16rem;
              height: .64rem;
            }
          }

          :deep(.footer) {
            bottom: 0;
            padding-left: .24rem;

            @media screen and (max-width:1360px) {
              padding-left: .16rem;
            }
          }

          :deep(.cover) {
            object-fit: cover;
          }
        }
      }

      .intro-text {
        width: 100%;
        margin-top: .32rem;

        @media screen and (max-width:1360px) {
          margin-top: .24rem;
        }
      }

      &.secondChannel .work-box {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        column-gap: .1rem;

        @media screen and (max-width:1360px) {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          column-gap: .1rem;
          row-gap: .08rem;
        }


        .photo {
          width: 5.36rem;
          height: 3rem;

          @media screen and (max-width:1360px) {
            width: auto;
            height: 1.86rem;
          }

          // &:not(:nth-of-type(n+5)) {
          //   margin-right: .1rem;

          //   @media screen and (max-width:1360px) {
          //     margin-right: 0;
          //   }
          // }
        }
      }
    }

    &.kuaishouPopularity {
      .work-wrapper {
        justify-content: center;

        .work-box {
          display: grid;
          grid-template-columns: repeat(1, 1fr);
        }

        &.first {
          display: flex;
          align-items: center;
          justify-content: center;

          .work-box {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        &.secondChannel {
          .work-box {
            display: grid;
            grid-template-columns: repeat(5, 1fr);

            @media screen and (max-width:1360px) {
              grid-template-columns: repeat(2, 1fr);
            }
          }

        }
      }
    }

    :deep(.title) {
      width: 100%;
      margin-bottom: .8rem;

      &.second:not(.popular) {
        margin-bottom: 0;
      }

      @media screen and (max-width:1360px) {
        margin-bottom: .24rem;
      }

      &.second {
        margin-top: 0.8rem;

        @media screen and (max-width:1360px) {
          margin-top: .4rem;
          margin-bottom: 0;
        }

        &.popular {
          @media screen and (max-width:1360px) {
            margin-bottom: .24rem;
          }
        }
      }
    }
  }

  .bottom-btn {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: .8rem;

    @media screen and (max-width:1360px) {
      margin-top: .16rem;
    }

    img {
      // width: 5.12rem;
      height: 1.2rem;

      @media screen and (max-width:1360px) {
        height: .8rem;
      }
    }
  }
}
</style>
